import React from 'react'
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import TitledComponent from 'components/TitledComponent';
import DateTimePicker from 'components/DateTimePicker';

const style = theme => ({
	root: {
		marginLeft: theme.spacing(2),
		marginTop: theme.spacing(2)
	}
})

function FormElement({
	classes,
	formikProps,
	id,
	title,
	required,
	onChange,
}) {
	let label = title;
	if (required) label += '*'

	return (
		<TitledComponent
			className={classes.root}
			title={label}
		>
			<DateTimePicker
				formikProps={formikProps}
				id={id}
				onChange={onChange}
				minDate={new Date()}
			/>
		</TitledComponent>
	)
}

FormElement.propTypes = {
	classes: PropTypes.any,
	id: PropTypes.string,
	title: PropTypes.string,
	formikProps: PropTypes.object,
}

FormElement.defaultProps = {
}

export default withStyles(style)(FormElement);